import './assets/main.css';
import { createApp } from 'vue';
import i18n from '@/i18n/index';
import CookieConsentVue from '@/plugins/cookieconsent/CookieConsentVue';
import { initDefaultConsent} from '@/services/analytics/googleAnalytics.js';
import initGTM from '@/services/analytics/initGTM.js';
import App from './App.vue';
import router from './router';
// Roboto (Standard)
import '@fontsource/roboto/100.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
// Lato
import '@fontsource/lato/100.css';
import '@fontsource/lato/300.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/lato/900.css';
// Inter (Variable font, covers all weights)
import '@fontsource-variable/inter';

const app = createApp(App);

app.use(router);
app.use(i18n);
app.config.errorHandler = (err, instance, info) => {
  console.error(err, instance, info); // eslint-disable-line no-console
};
app.use(CookieConsentVue);

app.mount('#app');

const { GTM_TOKEN } = process.env;
initDefaultConsent();
const tokens = [
  { name: 'GTM', token: GTM_TOKEN, init: initGTM },
];

tokens.forEach(({ name, token, init }) => {
  if (!token) {
    console.warn(`No ${name} token found.`);
  } else {
    init(token);
  }
});
